import React from 'react';
import HeroSection from '../../HeroSection';
import { homeObjThree } from './Data';

function Services() {
    return (
        <>
            <HeroSection {...homeObjThree} />
        </>
    );
}

export default Services;
